import { Typography } from 'antd'
import { SingleTaxonomyPanel } from './TaxonomiesTab'

const { Title } = Typography

/** LiangCollection "主题分类管理" (Topic) — its own routed page, independent
 * from "条目分类" (Category), matching Legacy's real sidebar IA (spec §1/§13). */
export default function TopicsTab({ workspaceId, siteId }: { workspaceId: string; siteId: string }) {
  return (
    <div>
      <Title level={4} style={{ marginTop: 0 }}>主题分类</Title>
      <SingleTaxonomyPanel workspaceId={workspaceId} siteId={siteId} taxonomyKey="topic" taxonomyName="主题分类" />
    </div>
  )
}
